/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "./confirmOrder.module.css";
const Tnc = (props) => {
  const terms = props.terms;
  return (
    <div>
      <div>
        <h1>
          Terms and Conditions
          <span className="highlight preview_company_name"></span>
        </h1>
        <p>
          By entering your name and clicking the “Accept Terms” button on the
          following page, you are agreeing to all terms and conditions of this
          order, including the Digitize Things Software as a Service (SaaS)
          Terms of Service and any applicable Product Specific Terms referenced
          below.
        </p>
        <ul>
          {terms.map((item, index) => (
            <li key={index}>
              <a
                className={classes.termsLink}
                href={item.termsUrl}
                target="blank"
              >
                {item.termsText}
              </a>
            </li>
          ))}
        </ul>
        <p>
          You also (i) represent that all information you have provided to
          Digitize Things is correct; and (ii) if acting on behalf of a
          business, represent that you have authorization to legally bind the
          business and agree to pay all charges if that business denies
          responsibility for this Order.
        </p>

        <p>
          This contract contains a binding aritration provision that may be
          enforced by the parties. Your service will automatically renew for
          additional terms of the same length as your initial term until you
          cancel the service. We will provide you notice of any price increase.
          You may cancel your service by contacting us by phone or through your{" "}
          {props.providerTitle} account at least (i) thirty (30) days before the
          end of an annual service, and (ii) five (5) days before the end of a
          monthly service. You may contact us at 855-234-1825 or through your
          account at{" "}
          <a href="">
            <span>{props.providerTitle}</span>
          </a>{" "}
          to cancel services or if you have any questions.
        </p>
      </div>
    </div>
  );
};

export default Tnc;
